import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITimelineChangeProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    TimelinePartContentProps
} from "../../type";
import {
    ArrowRight as ArrowRightIcon
} from "lucide-react-native";
import {
    withTimelineContext
} from "../../context";
import Badge from "../../../badge";
import Icon from "../../../icon";

const TimelineChangeContent: FC<TimelinePartContentProps<ITimelineChangeProps>> = ({
    customTheme: customThemeProp,
    context,
    style,
    from,
    to,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        iconSizes,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    return <View
        {...props}
        aria-label={`${from.title}, ${localize("timeline-new-value")}: ${to.title}`}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        accessible={true}
        role="group"
    >
        <Badge
            type={from.type ?? "neutral"}
            customTheme={customTheme}
            title={from.title}
            aria-hidden={true}
            icon={from.icon}
            size="small"
        />
        <Icon
            customColor={colors.content.icon.low}
            customTheme={customTheme}
            size={iconSizes.small}
            icon={ArrowRightIcon}
            aria-hidden={true}
        />
        <Badge
            type={to.type ?? "neutral"}
            customTheme={customTheme}
            aria-hidden={true}
            title={to.title}
            icon={to.icon}
            size="small"
        />
    </View>;
};
export default withTimelineContext("Change", TimelineChangeContent);
